// Claim workplace, also save experience for workplace ********************************************
// pathname: /v1/workplace/{slug}/claim
// method:   POST
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';
import { ApiRequestBody } from '@type/api/apiUtilityFn';

/**
 * @description SWR mutation: POST claim workplace follower also save experience for workplace. Response status ok: 200.
 * @param slug - string. The workplace slug.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. An optional callback to call on success.
 */
export const useSwrClaimWorkplace = (slug: string, locale: string = 'ro', successCallback?: () => void) => {
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiSchema<'WorkplaceProfile2'>, ApiRequestBody<'/v1/workplace/{slug}/claim', 'post'>>({
    url: `/v1/workplace/${slug}/claim`,
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
